<template>
  <div class="topicBox">
    <div class="gradientBox">
      <div class="titleBox">
        <div class="titleLeft" @click="closeWebs">
          <img src="../../assets/images/titleArrow.png" alt="" />
        </div>
        <div class="titleCentre">理论题库</div>
        <div class="titleRight"></div>
      </div>
      <div class="listBox">
        <div
          class="liBox"
          v-for="(item, index) in questionList"
          :key="index"
          :style="{ backgroundImage: `url(${item.bg})` }"
          @click="handleClick(item)"
        ></div>
      </div>
    </div>
  </div>
</template>

<script>
import { getToken, setToken } from "@/utils/auth";
export default {
  data() {
    return {
      questionList: [
        {
          type: 1,
          bg: require("../../assets/images/institutionImg.png"),
        },
        {
          type: 2,
          bg: require("../../assets/images/platformImg.png"),
        },
      ],
    };
  },
  created() {
    this.androidIos();
  },
  mounted() {
    window.getU3dParams = this.getU3dParams;
    window.buyFirstStaionActionBack = this.buyFirstStaionActionBack;
  },
  methods: {
    judgeClient() {
      let u = navigator.userAgent;
      let isAndroid = u.indexOf("Android") > -1 || u.indexOf("Adr") > -1;
      let isIOS = !!u.match(/\(i[^;]+;( U;)? CPU.+Mac OS X/);
      console.log("是否是Android：" + isAndroid);
      console.log("是否是iOS：" + isIOS);
      if (isAndroid) {
        return "Android";
      } else if (isIOS) {
        return "IOS";
      } else {
        return "PC";
      }
    },
    androidIos() {
      if (this.judgeClient() == "Android") {
        this.callAndroidFunctionWithParameter();
      } else {
        this.getAppParams();
      }
    },
    callAndroidFunctionWithParameter() {
      const that = this;
      this.$bridge.callmethod(
        "WebAction.getAppParams",
        { ceshi: "ceshi" },
        (res) => {}
      );
      this.$bridge.registermethod("getU3dParams", (data) => {
        const jsonData = JSON.parse(data);
        const token = jsonData.token;
        setToken(token);
        this.$nextTick(() => {
          this.getTreeList(token);
        });
      });
    },
    getU3dParams(data) {
      const jsonData = JSON.parse(data);
      const token = jsonData.token;
      setToken(token);
      this.$nextTick(() => {
        this.getTreeList(token);
      });
    },
    getAppParams() {
      try {
        webkit.messageHandlers.getAppParams.postMessage(
          "js调用ios",
          (data) => {}
        );
      } catch (error) {
        console.log("WKWebView post message error: ", error);
      }
    },
    closeWebs() {
      if (this.judgeClient() == "Android") {
        this.closeAndroid();
      } else {
        this.closeIos();
      }
    },
    closeAndroid() {
      this.$bridge.callmethod(
        "WebAction.closeWeb",
        { ceshi: "ceshi" },
        (res) => {}
      );
    },
    closeIos() {
      try {
        webkit.messageHandlers.closeWeb.postMessage("js调用ios");
      } catch (error) {
        console.log("WKWebView post message error: ", error);
      }
    },
    handleClick(item) {
      this.$router.push({
        path: "/topic",
        query: {
          questionType: item.type,
        },
      });
    },
  },
};
</script>

<style lang="scss" scoped>
.topicBox {
  .gradientBox {
    width: 100%;
    .titleBox {
      padding: 44px 16px 0 16px;
      display: flex;
      justify-content: space-between;
      align-items: center;
      .titleLeft {
        text-align: center;
        line-height: 20px;
        width: 20px;
        height: 20px;
        img {
          width: 20px;
          height: 20px;
        }
      }
      .titleCentre {
        font-family: PingFangSC, PingFang SC;
        font-weight: 500;
        font-size: 17px;
        color: #121212;
      }
      .titleRight {
        width: 20px;
        height: 20px;
      }
    }
    .listBox {
      margin-top: 25px;
      padding: 0 16px;
      width: 100%;
      box-sizing: border-box;
      .liBox {
        width: 100%;
        height: 110px;
        margin-bottom: 12px;
        border-radius: 12px;
        background-size: 100% 100%;
        background-repeat: no-repeat;
        background-position: center;
      }
    }
  }
}
</style>